import { gql } from '@apollo/client';

export * from './appMembershipRemove.mutation.generated';

export const APP_MEMBERSHIP_REMOVE = gql`
  mutation appMembershipRemove($appMembershipId: ID!) {
    appMembershipRemove(input: { appMembershipId: $appMembershipId }) {
      errors
      success
    }
  }
`;
